const React = require('react')
const PropTypes = require('prop-types')

// this is a wrapper component which just provides context objects to its
// children

class AppContext extends React.Component {

    getChildContext() {
        return {
            insertCss: this.props.insertCss,
            globals: this.props.globals,
            viewer: this.props.viewer,
            page: this.props.page,
        }
    }

    render() {
        return this.props.children
    }

}

AppContext.propTypes = {
    insertCss: PropTypes.func.isRequired,
    globals: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
}

AppContext.childContextTypes = {
    insertCss: PropTypes.func,
    globals: PropTypes.object,
    viewer: PropTypes.object,
    page: PropTypes.object,
}

module.exports = AppContext
